<template>
  <div>
    <a-row style="margin-top: 0" :gutter="[24, 24]">
      <client-summary-statistics :uri="routeUri('report.transaction.summary')"></client-summary-statistics>
      <a-col :xs="24" :sm="24" :md="12" :lg="12">
        <chart-value-container :uri="routeUri('report.transaction.summary.value')"></chart-value-container>
      </a-col>
      <a-col :xs="24" :sm="24" :md="12" :lg="12">
        <chart-top-product-container :uri="routeUri('report.transaction.summary')"></chart-top-product-container>
      </a-col>
    </a-row>
  </div>
</template>

<script>
import ChartValueContainer from "./chart/transaction/chart-value-container";
import ClientSummaryStatistics from "./chart/transaction/client-summary-statistics";
import ChartTopProductContainer from "./chart/product/chart-top-product-container";
export default {
  name: "report-dashboard",
  components: {
    ChartTopProductContainer, ClientSummaryStatistics, ChartValueContainer},
}
</script>

<style scoped>

</style>
